import { render } from "./PabloAssistant.vue?vue&type=template&id=0be1952e&scoped=true"
import script from "./PabloAssistant.vue?vue&type=script&lang=js"
export * from "./PabloAssistant.vue?vue&type=script&lang=js"

import "./PabloAssistant.vue?vue&type=style&index=0&id=0be1952e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be1952e"]])

export default __exports__